// extracted by mini-css-extract-plugin
module.exports = {"staticPageWrapper":"AmbassadorProgram_staticPageWrapper__TWNTX"};